import React, { useState, useEffect } from 'react';

interface Props {
  startsAt: string;
}

export function CountdownTimer({ startsAt }: Props): React.ReactElement {
  const [countdown, setCountdown] = useState<string>('');

  useEffect(() => {
    const updateCountdown = () => {
      const now = Date.now();
      const startTime = new Date(startsAt).getTime();
      const diff = startTime - now;

      if (diff <= 0) {
        setCountdown('Starting soon...');
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      const pad = (num: number) => String(num).padStart(2, '0');

      // Always show consistent format with zero-padding
      setCountdown(`${pad(days)}d ${pad(hours)}h ${pad(minutes)}m ${pad(seconds)}s`);
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, [startsAt]);

  if (!countdown) return <></>;

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.content}>
          <div style={styles.label}>Starts in</div>
          <div style={styles.time}>{countdown}</div>
        </div>
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  card: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '12px',
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: '16px',
    paddingRight: '16px',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  label: {
    color: '#999',
    fontSize: '12px',
    fontWeight: 600,
    letterSpacing: '0.5px',
    marginBottom: '8px',
    marginTop: '8px',
    textTransform: 'uppercase',
  },
  time: {
    color: '#3b82f6',
    fontSize: '36px',
    fontWeight: 'bold',
  },
};
